import dynamic from 'next/dynamic';

const DriversPageContent = dynamic(() => import('./DriversPageContent'));

export { DriversPageContent };
